const isImageLoaded = ($img) => {
	if (!$img.complete) return false;
	if (typeof $img.naturalWidth !== 'undefined' && $img.naturalWidth === 0) return false;
	return true;
};

const imageSizeTranslation = (columnWidth, imageObj, lazyLoad = true, limitLower = false) => {
	const returnObj = {};
	let width = 1;
	columnWidth = columnWidth.toString();
	if (/\.(svg|gif)$/.test(imageObj.url)) columnWidth = 'noResize';
	switch (columnWidth) {
		case 'full':
			width = 2000;
			returnObj.src = imageObj.sizes[20];
			returnObj.srcSet = `${imageObj.sizes[20]} 2000w, ${imageObj.sizes[16]} 1600w, ${imageObj.sizes[12]} 1200w${(limitLower ? '' : `, ${imageObj.sizes[8]} 800w, ${imageObj.sizes[4]} 400w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 400px) 400px, (max-width: 800px) 800px, ')}(max-width: 1200px) 1200px, (max-width: 1600px) 1600px, 2000px`;
			break;
		case '12':
		case '11':
		case '10':
			width = 1600;
			returnObj.src = imageObj.sizes[16];
			returnObj.srcSet = `${imageObj.sizes[16]} 1600w, ${imageObj.sizes[12]} 1200w${(limitLower ? '' : `, ${imageObj.sizes[8]} 800w, ${imageObj.sizes[4]} 400w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 400px) 400px, (max-width: 800px) 800px, ')}(max-width: 1200px) 1200px, 1600px`;
			break;
		case '9':
		case '8':
		case '7':
			width = 1200;
			returnObj.src = imageObj.sizes[12];
			returnObj.srcSet = `${imageObj.sizes[12]} 1200w${(limitLower ? '' : `, ${imageObj.sizes[8]} 800w, ${imageObj.sizes[4]} 400w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 400px) 400px, (max-width: 800px) 800px, ')}1200px`;
			break;
		case '6':
		case '5':
		case '4':
			width = 800;
			returnObj.src = imageObj.sizes[8];
			returnObj.srcSet = `${imageObj.sizes[8]} 800w, ${imageObj.sizes[4]} 400w`;
			returnObj.sizes = '(max-width: 400px) 400px, 800px';
			break;
		case '3':
		case '2':
		case '1':
			width = 400;
			returnObj.src = imageObj.sizes[4];
			break;
		default:
			width = imageObj.width;
			returnObj.src = imageObj.url;
	}
	returnObj.alt = imageObj.alt;
	returnObj.width = width;
	if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * width);
	if (lazyLoad) returnObj.className = 'js-lazyLoad';
	return returnObj;
};

export { isImageLoaded, imageSizeTranslation };
